export type PanelGroup = 'overview' | 'context' | 'params';

export type PanelDef = {
  id: string;
  group: PanelGroup;
  nameKey: string;
  descKey: string;
  icon: string;
  defaultOn: boolean;
  full: boolean;
};

export const PANEL_REGISTRY: PanelDef[] = [
  {
    id: 'lives',
    group: 'overview',
    nameKey: 'analytics.dashboard.panel.lives.name',
    descKey: 'analytics.dashboard.panel.lives.desc',
    icon: 'BarChart2',
    defaultOn: true,
    full: false,
  },
  {
    id: 'anomalies',
    group: 'overview',
    nameKey: 'analytics.dashboard.panel.anomalies.name',
    descKey: 'analytics.dashboard.panel.anomalies.desc',
    icon: 'AlertTriangle',
    defaultOn: true,
    full: false,
  },
  {
    id: 'machine',
    group: 'context',
    nameKey: 'analytics.dashboard.panel.machine.name',
    descKey: 'analytics.dashboard.panel.machine.desc',
    icon: 'Settings2',
    defaultOn: true,
    full: false,
  },
  {
    id: 'material',
    group: 'context',
    nameKey: 'analytics.dashboard.panel.material.name',
    descKey: 'analytics.dashboard.panel.material.desc',
    icon: 'Layers',
    defaultOn: false,
    full: false,
  },
  {
    id: 'vc',
    group: 'params',
    nameKey: 'analytics.dashboard.panel.vc.name',
    descKey: 'analytics.dashboard.panel.vc.desc',
    icon: 'Gauge',
    defaultOn: true,
    full: false,
  },
  {
    id: 'fz',
    group: 'params',
    nameKey: 'analytics.dashboard.panel.fz.name',
    descKey: 'analytics.dashboard.panel.fz.desc',
    icon: 'MoveRight',
    defaultOn: false,
    full: false,
  },
  {
    id: 'ap',
    group: 'params',
    nameKey: 'analytics.dashboard.panel.ap.name',
    descKey: 'analytics.dashboard.panel.ap.desc',
    icon: 'ArrowDown',
    defaultOn: false,
    full: false,
  },
];
